import { Routes } from '@angular/router';
import { AuthConfirmationRequiredComponent } from './confirmation-required/confirmation-required.component';
import { AuthForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { AuthResetPasswordComponent } from './reset-password/reset-password.component';
import { AuthSignInComponent } from './sign-in/sign-in.component';
import { AuthSignOutComponent } from './sign-out/sign-out.component';
import { TwoFaComponent } from './two-fa/two-fa.component';
import { AuthUnlockSessionComponent } from './unlock-session/unlock-session.component';

/** Auth routes accessible only for non-authenticated users (guests) */
export const guestAuthRoutes: Routes = [
    {
        path: 'confirmation-required',
        component: AuthConfirmationRequiredComponent,
    },
    { path: 'forgot-password', component: AuthForgotPasswordComponent },
    { path: 'reset-password', component: AuthResetPasswordComponent },
    { path: 'sign-in', component: AuthSignInComponent },
    // { path: 'sign-up', component: AuthSignUpComponent },
    { path: 'verify-2fa', component: TwoFaComponent },
];

/** Auth routes accessible only for authenticated users */
export const authenticatedAuthRoutes: Routes = [
    { path: 'sign-out', component: AuthSignOutComponent },
    { path: 'unlock-session', component: AuthUnlockSessionComponent },
];
